<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    fill="none"
    viewBox="0 0 16 17"
  >
    <path
      fill="#9C9AA0"
      fill-rule="evenodd"
      d="M4.667 11.167c0-.367.3-.667.666-.667.367 0 .667.3.667.667 0 .366-.3.666-.667.666a.669.669 0 0 1-.666-.666ZM8 10.5h2.667c.366 0 .666.3.666.667 0 .366-.3.666-.666.666H8a.669.669 0 0 1-.667-.666c0-.367.3-.667.667-.667Zm4 3.333H4a.668.668 0 0 1-.667-.666v-4h9.334v4c0 .367-.3.666-.667.666ZM4 4.5h.667v.667c0 .366.3.666.666.666.367 0 .667-.3.667-.666V4.5h4v.667c0 .366.3.666.667.666.366 0 .666-.3.666-.666V4.5H12c.367 0 .667.3.667.667v2.666H3.333V5.167c0-.368.3-.667.667-.667Zm8-1.333h-.667V2.5c0-.367-.3-.667-.666-.667-.367 0-.667.3-.667.667v.667H6V2.5c0-.367-.3-.667-.667-.667-.366 0-.666.3-.666.667v.667H4c-1.103 0-2 .897-2 2v8c0 1.102.897 2 2 2h8c1.103 0 2-.898 2-2v-8c0-1.103-.897-2-2-2Z"
      clip-rule="evenodd"
    />
  </svg>
</template>
